import { render } from "./Trade.vue?vue&type=template&id=6177ac86&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"

import "./Trade.vue?vue&type=style&index=0&id=6177ac86&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6177ac86"]])

export default __exports__